<template>
  <section
    class="features-tabs section"
    :class="[
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color',
    ]"
  >
    <div class="container">
      <div
        class="features-tabs-inner section-inner"
        :class="[
          topDivider && 'has-top-divider',
          bottomDivider && 'has-bottom-divider',
        ]"
      >
        <c-section-header :data="sectionHeader" class="center-content" />
        <c-tabs active="tab-a">
          <c-tab-list class="center-content">
            <c-tab tabId="tab-a">
              <div class="features-tabs-tab-image secondary-color mb-12">
                <c-image
                  :src="require('@/assets/images/features-tabs-icon-01.svg')"
                  alt="Tab icon 01"
                  :width="56"
                  :height="56"
                />
              </div>
              <div class="text-color-high fw-600 text-sm">
                {{ $t("employer.projects.inreal.category") }}
              </div>
            </c-tab>
            <c-tab tabId="tab-b">
              <div class="features-tabs-tab-image mb-12">
                <c-image
                  :src="require('@/assets/images/features-tabs-icon-02.svg')"
                  alt="Tab icon 02"
                  :width="56"
                  :height="56"
                />
              </div>
              <div class="text-color-high fw-600 text-sm">
                {{ $t("employer.projects.enpal.category") }}
              </div>
            </c-tab>
            <c-tab tabId="tab-c">
              <div class="features-tabs-tab-image mb-12">
                <c-image
                  :src="require('@/assets/images/features-tabs-icon-03.svg')"
                  alt="Tab icon 03"
                  :width="56"
                  :height="56"
                />
              </div>
              <div class="text-color-high fw-600 text-sm">
                {{ $t("employer.projects.autoretouch.category") }}
              </div>
            </c-tab>
            <c-tab tabId="tab-d">
              <div class="features-tabs-tab-image mb-12">
                <c-image
                  :src="require('@/assets/images/features-tabs-icon-04.svg')"
                  alt="Tab icon 04"
                  :width="56"
                  :height="56"
                />
              </div>
              <div class="text-color-high fw-600 text-sm">
                {{ $t("employer.projects.custom.category") }}
              </div>
            </c-tab>
          </c-tab-list>
          <c-tab-panel id="tab-a" class="has-shadow container">
            <div class="row">
              <div class="tiles-wrap" :class="[pushLeft && 'push-left']">
                <div
                  class="tiles-item reveal-from-bottom"
                  data-reveal-container=".tiles-wrap"
                >
                  <div class="features-tiles-item-content">
                    <p class="text-xs">
                      {{ $t("employer.projects.inreal.industry") }}
                    </p>
                    <h3>
                      {{ $t("employer.projects.inreal.headline") }}
                    </h3>
                    <p>
                      {{ $t("employer.projects.inreal.paragraph") }}
                    </p>
                    <div class="row">
                      <div class="tiles-wrap">
                        <div
                          class="tiles-item-xs center-content"
                          data-reveal-container=".tiles-wrap"
                        >
                          <h4 class="text-color-primary">
                            {{ $t("employer.projects.inreal.fact.one.value") }}
                          </h4>

                          <p>
                            {{ $t("employer.projects.inreal.fact.one.label") }}
                          </p>
                        </div>
                        <div
                          class="tiles-item-xs center-content"
                          data-reveal-container=".tiles-wrap"
                        >
                          <h4 class="text-color-primary">
                            {{ $t("employer.projects.inreal.fact.two.value") }}
                          </h4>
                          <p>
                            {{ $t("employer.projects.inreal.fact.two.label") }}
                          </p>
                        </div>
                        <div
                          class="tiles-item-xs center-content"
                          data-reveal-container=".tiles-wrap"
                        >
                          <h4 class="text-color-primary">
                            {{
                              $t("employer.projects.inreal.fact.three.value")
                            }}
                          </h4>
                          <p>
                            {{
                              $t("employer.projects.inreal.fact.three.label")
                            }}
                          </p>
                        </div>
                        <div
                          class="tiles-item-xs"
                          data-reveal-container=".tiles-wrap"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="tiles-item reveal-from-bottom"
                  data-reveal-container=".tiles-wrap"
                >
                  <div class="features-tiles-item-content">
                    <c-image
                      :src="require('@/assets/images/customer-usecase-03.jpg')"
                      :width="500"
                      :height="450"
                    />
                  </div>
                </div>
              </div>
            </div>
          </c-tab-panel>
          <c-tab-panel id="tab-b" class="has-shadow">
            <div class="row">
              <div class="tiles-wrap" :class="[pushLeft && 'push-left']">
                <div
                  class="tiles-item reveal-from-bottom"
                  data-reveal-container=".tiles-wrap"
                >
                  <div class="features-tiles-item-content">
                    <p class="text-xs">
                      {{ $t("employer.projects.enpal.industry") }}
                    </p>
                    <h3>
                      {{ $t("employer.projects.enpal.headline") }}
                    </h3>
                    <p>
                      {{ $t("employer.projects.enpal.paragraph") }}
                    </p>
                    <div class="row">
                      <div class="tiles-wrap">
                        <div
                          class="tiles-item-xs center-content"
                          data-reveal-container=".tiles-wrap"
                        >
                          <h4 class="text-color-primary">
                            {{ $t("employer.projects.enpal.fact.one.value") }}
                          </h4>

                          <p>
                            {{ $t("employer.projects.enpal.fact.one.label") }}
                          </p>
                        </div>
                        <div
                          class="tiles-item-xs center-content"
                          data-reveal-container=".tiles-wrap"
                        >
                          <h4 class="text-color-primary">
                            {{ $t("employer.projects.enpal.fact.two.value") }}
                          </h4>
                          <p>
                            {{ $t("employer.projects.enpal.fact.two.label") }}
                          </p>
                        </div>
                        <div
                          class="tiles-item-xs center-content"
                          data-reveal-container=".tiles-wrap"
                        >
                          <h4 class="text-color-primary">
                            {{ $t("employer.projects.enpal.fact.three.value") }}
                          </h4>
                          <p>
                            {{ $t("employer.projects.enpal.fact.three.label") }}
                          </p>
                        </div>
                        <div
                          class="tiles-item-xs"
                          data-reveal-container=".tiles-wrap"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="tiles-item reveal-from-bottom"
                  data-reveal-container=".tiles-wrap"
                >
                  <div class="features-tiles-item-content">
                    <c-image
                      :src="require('@/assets/images/customer-usecase-02.jpg')"
                      :width="500"
                      :height="450"
                    />
                  </div>
                </div>
              </div>
            </div>
          </c-tab-panel>
          <c-tab-panel id="tab-c" class="has-shadow">
            <div class="row">
              <div class="tiles-wrap" :class="[pushLeft && 'push-left']">
                <div
                  class="tiles-item reveal-from-bottom"
                  data-reveal-container=".tiles-wrap"
                >
                  <div class="features-tiles-item-content">
                    <p class="text-xs">
                      {{ $t("employer.projects.autoretouch.industry") }}
                    </p>
                    <h3>
                      {{ $t("employer.projects.autoretouch.headline") }}
                    </h3>
                    <p>
                      {{ $t("employer.projects.autoretouch.paragraph") }}
                    </p>
                    <div class="row">
                      <div class="tiles-wrap">
                        <div
                          class="tiles-item-xs center-content"
                          data-reveal-container=".tiles-wrap"
                        >
                          <h4 class="text-color-primary">
                            {{
                              $t("employer.projects.autoretouch.fact.one.value")
                            }}
                          </h4>

                          <p>
                            {{
                              $t("employer.projects.autoretouch.fact.one.label")
                            }}
                          </p>
                        </div>
                        <div
                          class="tiles-item-xs center-content"
                          data-reveal-container=".tiles-wrap"
                        >
                          <h4 class="text-color-primary">
                            {{
                              $t("employer.projects.autoretouch.fact.two.value")
                            }}
                          </h4>
                          <p>
                            {{
                              $t("employer.projects.autoretouch.fact.two.label")
                            }}
                          </p>
                        </div>
                        <div
                          class="tiles-item-xs center-content"
                          data-reveal-container=".tiles-wrap"
                        >
                          <h4 class="text-color-primary">
                            {{
                              $t(
                                "employer.projects.autoretouch.fact.three.value"
                              )
                            }}
                          </h4>
                          <p>
                            {{
                              $t(
                                "employer.projects.autoretouch.fact.three.label"
                              )
                            }}
                          </p>
                        </div>
                        <div
                          class="tiles-item-xs"
                          data-reveal-container=".tiles-wrap"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="tiles-item reveal-from-bottom"
                  data-reveal-container=".tiles-wrap"
                >
                  <div class="features-tiles-item-content">
                    <c-image
                      :src="require('@/assets/images/customer-usecase-01.jpg')"
                      :width="500"
                      :height="450"
                    />
                  </div>
                </div>
              </div>
            </div>
          </c-tab-panel>
          <c-tab-panel id="tab-d" class="has-shadow">
            <div class="row">
              <div class="tiles-wrap" :class="[pushLeft && 'push-left']">
                <div
                  class="tiles-item reveal-from-bottom"
                  data-reveal-container=".tiles-wrap"
                >
                  <div class="features-tiles-item-content">
                    <p class="text-xs">
                      {{ $t("employer.projects.custom.industry") }}
                    </p>
                    <h3>
                      {{ $t("employer.projects.custom.headline") }}
                    </h3>
                    <p>
                      {{ $t("employer.projects.custom.paragraph") }}
                    </p>
                    <div class="row">
                      <div class="tiles-wrap">
                        <div
                          class="tiles-item-xs center-content"
                          data-reveal-container=".tiles-wrap"
                        >
                          <h4 class="text-color-primary">
                            {{
                              $t("employer.projects.custom.fact.one.value")
                            }}
                          </h4>

                          <p>
                            {{
                              $t("employer.projects.custom.fact.one.label")
                            }}
                          </p>
                        </div>
                        <div
                          class="tiles-item-xs center-content"
                          data-reveal-container=".tiles-wrap"
                        >
                          <h4 class="text-color-primary">
                            {{
                              $t("employer.projects.custom.fact.two.value")
                            }}
                          </h4>
                          <p>
                            {{
                              $t("employer.projects.custom.fact.two.label")
                            }}
                          </p>
                        </div>
                        <div
                          class="tiles-item-xs center-content"
                          data-reveal-container=".tiles-wrap"
                        >
                          <h4 class="text-color-primary">
                            {{
                              $t(
                                "employer.projects.custom.fact.three.value"
                              )
                            }}
                          </h4>
                          <p>
                            {{
                              $t(
                                "employer.projects.custom.fact.three.label"
                              )
                            }}
                          </p>
                        </div>
                        <div
                          class="tiles-item-xs"
                          data-reveal-container=".tiles-wrap"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="tiles-item reveal-from-bottom"
                  data-reveal-container=".tiles-wrap"
                >
                  <div class="features-tiles-item-content">
                    <c-image
                      :src="require('@/assets/images/customer-usecase-04.jpg')"
                      :width="500"
                      :height="450"
                    />
                  </div>
                </div>
              </div>
            </div>
          </c-tab-panel>
        </c-tabs>
      </div>
    </div>
  </section>
</template>

<script>
import { SectionProps } from "@/utils/SectionProps.js";
import CSectionHeader from "@/components/sections/partials/SectionHeader.vue";
import CTabs, {
  CTabList,
  CTab,
  CTabPanel,
} from "@/components/elements/Tabs.vue";
import CImage from "@/components/elements/Image.vue";

export default {
  name: "CFeaturesTabs",
  components: {
    CSectionHeader,
    CTabs,
    CTab,
    CTabPanel,
    CTabList,
    CImage,
  },
  mixins: [SectionProps],
  computed: {
    sectionHeader() {
      return {
        title: this.$i18n.t("employer.projects.title"),
        paragraph: this.$i18n.t("employer.projects.paragraph"),
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-panel .row {
  padding: 32px;
}

.tiles-item {
  -ms-flex-preferred-size: 480px;
  flex-basis: 480px;
  max-width: 480px;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  .row {
    padding: 0px !important;
  }
}

.tiles-item-xs {
  -ms-flex-preferred-size:118px;
  flex-basis: 118px;
  max-width: 118px;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  margin-right: 8px;
  h4 {
    margin-bottom: 0px !important;
  }
}

.features-tiles-item-content {
  img {
    border-radius: 4px;
  }
}

.features-tabs-tab-image {
  background: #ff6163 !important;
}
</style>
